import React from 'react'
import higherEducation from '../assets/images/higher-education.png'
import nohigherEducation from '../assets/images/no-higher-education.png'

const EducationChart = ({ data }) => {
  let higherCount = 0
  let nonHigherCount = 0

  data.forEach((d) => {
    const edu = d.Education?.trim().toLowerCase()
    if (edu === 'higher education') {
      higherCount++
    } else {
      nonHigherCount++
    }
  })

  const total = higherCount + nonHigherCount
  const higherPercent = total ? ((higherCount / total) * 100).toFixed(0) : 0
  const nonHigherPercent = total ? ((nonHigherCount / total) * 100).toFixed(0) : 0

  return (
    <div className="bg-white rounded shadow p-4 w-full">
      <h2 className="font-semibold text-sm text-gray-700 mb-4">EDUCATION</h2>
      <div className="flex items-center justify-around space-x-4">
        {/* Higher Education */}
        <div className="flex flex-col items-center">
          <div className="relative w-24 h-24">
            <svg className="w-full h-full transform -rotate-90">
              <circle
                cx="48"
                cy="48"
                r="42"
                stroke="#e5e7eb"
                strokeWidth="12"
                fill="none"
              />
              <circle
                cx="48"
                cy="48"
                r="42"
                stroke="#38bdf8"
                strokeWidth="12"
                fill="none"
                strokeDasharray={`${(higherPercent * 264) / 100}, 264`}
              />
            </svg>
            <img
              src={higherEducation}
              alt="Higher Education"
              className="w-10 h-10 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
            />
          </div>
          <div className="mt-2 text-sm font-medium text-gray-700">Higher Education</div>
          <div className="text-lg font-bold">{higherPercent}%</div>
        </div>

        {/* No Higher Education */}
        <div className="flex flex-col items-center">
          <div className="relative w-24 h-24">
            <svg className="w-full h-full transform -rotate-90">
              <circle
                cx="48"
                cy="48"
                r="42"
                stroke="#e5e7eb"
                strokeWidth="12"
                fill="none"
              />
              <circle
                cx="48"
                cy="48"
                r="42"
                stroke="#f472b6"
                strokeWidth="12"
                fill="none"
                strokeDasharray={`${(nonHigherPercent * 264) / 100}, 264`}
              />
            </svg>
            <img
              src={nohigherEducation}
              alt="No Higher Education"
              className="w-10 h-10 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
            />
          </div>
          <div className="mt-2 text-sm font-medium text-gray-700">No Higher Education</div>
          <div className="text-lg font-bold">{nonHigherPercent}%</div>
        </div>
      </div>
    </div>
  )
}

export default EducationChart
